import { Injectable } from '@angular/core';
import { AuthHttp, AuthConfig } from 'angular2-jwt';
import { Http, RequestOptions, Response } from '@angular/http';
import { AppConfig } from '../../../app.config';
import { AuthTokenService } from '../../../services/auth/auth-token.service';
import { Observable } from 'rxjs/Observable';


@Injectable()
export class FileUploadService {

  private authHttp: AuthHttp;

  constructor(private http: Http, private options: RequestOptions, private authTokenService: AuthTokenService, private config: AppConfig) {
    this.authHttp = this.authHttpServiceFactory(http, options, authTokenService, config);
  }

  upload(file: File, filePath: string, callback: (upload: Observable<Response>) => any) {
      const serverUrl = this.config.getValue('endPoint');
      this.authHttp.get(encodeURI(serverUrl + 'file-upload/url/' + filePath + '/' + file.name))
        .toPromise()
        .then(preSignedUrlResponse => {
          const fileReader = new FileReader();
          const that = this;
          fileReader.addEventListener('load', function(event: any) {
            callback(that.http.put(JSON.parse(preSignedUrlResponse.text()).url, event.target.result));
          });
          fileReader.readAsArrayBuffer(file);
        })
        .catch(error => {
          callback(Observable.throw(error));
        });
  }

  private authHttpServiceFactory(http: Http, options: RequestOptions, authTokenService: AuthTokenService, config: AppConfig) {
    return new AuthHttp(new AuthConfig({
      tokenGetter: (() => authTokenService.getToken()),
      globalHeaders: [{'x-api-key': config.getValue('mapApiKey')}]
    }), http, options);
  }
}



// WEBPACK FOOTER //
// ./app/widgets/templateDrivenWidget/proxyServices/file-upload.service.ts